import _ from 'lodash'
import authorization from 'live/services/authorization'

const { user } = authorization

const isAdmin = () => Live.Permission.ADMIN || Live.Permission.SUPER_USER

export default {
    canEditAnnotation (annotation) {
        const id = _.get(annotation, 'author.id', _.get(annotation, 'authorId', null))

        return isAdmin() || (id == user.id && this.canCreateAnnotations()) // eslint-disable-line
    },
    canCreateAnnotations () {
        return isAdmin() || Live.Permission.EDIT_ANNOTATIONS
    }
}
